import React from "react";
import PropTypes from "prop-types";

const Horizon = ({ className }) => (
  <svg className={className} viewBox="0 0 1440 842" fill="none">
    <g clipPath="url(#clip0)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M-34 0H1478V535.023L1392.61 755.685L1339.28 492L1334.3 737.161L1163.64 572.174L1295.55 791.318L1100 709.362L1334.3 962H1478V1052H-34V1019.16L-12.7733 1042H280L217.147 896.005L271.89 642.068L128.342 800.256L170.109 507L53.7292 807.152L-7.0963 507L-12.7733 786.066L-34 765.585V0ZM1478 727.575V609.125L1458.03 749.627L1478 727.575Z"
        fill="white"
      />
      <path
        d="M-202.754 609.634L-203.532 610.252L-71.2507 822.416L-269.861 764.799L-271.592 764.297L-270.367 765.619L-151.988 893.34L-151.82 893.522L-151.573 893.498L195.048 859.844L195.36 859.814L195.469 859.52L270.469 656.383L269.636 655.867L117.85 816.936L155.361 518.821L154.388 518.607L67.723 790.734L-15.3309 506.86L-16.3106 507.015L-7.42923 805.39L-202.754 609.634Z"
        stroke="black"
      />
      <path
        d="M1167.19 582.094L1166.42 582.712L1282.69 768.908L1108.14 718.351L1106.41 717.849L1107.63 719.171L1211.76 831.34L1211.93 831.522L1212.18 831.498L1517.08 801.942L1517.39 801.912L1517.5 801.618L1583.47 623.215L1582.64 622.699L1449.25 764.022L1482.22 502.389L1481.25 502.175L1405.07 740.98L1332.07 491.859L1331.09 492.015L1338.9 753.907L1167.19 582.094Z"
        stroke="black"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="1440" height="842" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

Horizon.defaultProps = {
  className: ``
};

Horizon.propTypes = {
  className: PropTypes.string
};

export default Horizon;
